// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SwiperStyle[data-v-18cbfe86]{width:100%}.SwiperStyle .my-swipe .van-swipe-item[data-v-18cbfe86]{color:#fff;font-size:20px;height:200px;line-height:200px;text-align:center;border-radius:10px}.SwiperStyle .swipe_img[data-v-18cbfe86]{width:100%;height:200px;border-radius:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
